import { AuthenticationResult, LogLevel, PublicClientApplication } from '@azure/msal-browser';

let instance: PublicClientApplication | null = null;
let failedLogin: string | null = null;

const loginRequest = { scopes: ['User.Read'] };

// Guest users (e.g. gmail addresses) only exist in the Wocozon tenant; `common` resolves
// to the user's home directory and fails with "cannot find account".
export function initMsal(clientId: string, tenantId?: string): void {
  instance = new PublicClientApplication({
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId || 'common'}`,
      redirectUri: window.location.origin,
      // Process the redirect response where it lands instead of navigating back
      // to the initiating page first; the extra navigation can drop the auth
      // response, forcing the user to log in twice.
      navigateToLoginRequestUrl: false,
    },
    cache: { cacheLocation: 'sessionStorage' },
    system: {
      loggerOptions: {
        loggerCallback: (_level: LogLevel, message: string) => {
          if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.log(`[msal] ${message}`);
          }
        },
        logLevel: process.env.NODE_ENV !== 'production' ? LogLevel.Warning : LogLevel.Error,
      },
    },
  });
}

function getMsal(): PublicClientApplication {
  if (!instance) {
    throw new Error('MSAL is not initialized');
  }

  return instance;
}

export function loginRedirect(): Promise<void> {
  return getMsal().loginRedirect(loginRequest);
}

// Resolves with the auth result when returning from the Azure redirect, null otherwise
export function handleRedirect(): Promise<AuthenticationResult | null> {
  return getMsal().handleRedirectPromise();
}

// Kept out of the store, which is persisted, so the message shows once and not after every reload
export function rememberFailedLogin(message: string): void {
  failedLogin = message;
}

export function takeFailedLogin(): string | null {
  const message = failedLogin;
  failedLogin = null;

  return message;
}
